import { useEffect, useState } from "react";
import { Box, Icon, IconButton, Stack, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { CanalDistribuicaoViewProps } from "../canalDist.controll";
import { formatData, formatMoney } from "../../../services/utils";
import { Select as ViewList } from "../../../components/select";
import { Movimentacao } from "../../../data.types";
import { getDescPagamento, handleShowModalCadMov } from "../../movimentacoes/view/mov.list";
import Modal from "../../../components/modal";
import { ItemMovList } from "../../movimentacoes/view/components/itemMovListView";
import { Newspaper ,ViewList  as ViewListIcon} from "@mui/icons-material";
import { MovCadastroView } from "../../movimentacoes/view/mov.cad";


const columns: GridColDef[] = [
    { field: 'codigo', headerName: 'Código', flex: 1 },
    { field: 'tipo_mov.descricao', headerName: 'Tipo', flex: 1, valueGetter: (value, row: Movimentacao) => row.tipo_mov.descricao },
    { field: 'created_at', headerName: 'Data', flex: 2, renderCell: (prm) => formatData(prm.value) },
    { field: 'pessoa.nome', headerName: 'Cliente', flex: 3, valueGetter: (value, row: Movimentacao) => row.pessoa.nome },
    { field: 'fechamento.pagamentos', headerName: 'Pagamentos', flex: 2, valueGetter: (value, row: Movimentacao) => getDescPagamento(row.fechamento) },
    { field: 'fechamento.total', headerName: 'Total', flex: 2, valueGetter: (value, row: Movimentacao) => formatMoney(row.fechamento.total) },
    { field: "_id", headerName: "Ações", flex:1, renderCell:(prm)=>{
        return (
            <Stack display={"flex"} flexDirection={"row"} gap={1}>
                <IconButton onClick={()=>handleShowModalCadMov(prm.row,true)} size="small" title="Visualizar movimentação">
                    <Newspaper />
                </IconButton>              
            </Stack>
        )
    }}
]

export function CanalDistMov(props: CanalDistribuicaoViewProps) {
    const { row, rowsMovCanal, loading, changeList, filtroMovCanal } = props.canalDistribuicaoState;
    const [showMovItensCanalDist, setShowMovItensCanalDist] = useState<{mov:Movimentacao,showModal:boolean}>();

    console.log("modal ",showMovItensCanalDist)

    const loadMovimentacoes = () => {
        props.canalDistribuicaoActions.readMovsCanal({ canal_id: row._id });
    }

    const ViewItensMovModal = () => {
        return (
            <Modal 
                component={
                    <ItemMovList 
                        mov={showMovItensCanalDist?.mov as Movimentacao} 
                        showButtonNew={false}  
                        handleAddItem={()=>{}}
                        handleAlterar={()=>{}}
                        handleClose={()=>setShowMovItensCanalDist({mov:{} as Movimentacao, showModal:false})}
                    />
                }
                handleClose={()=>setShowMovItensCanalDist({mov:{} as Movimentacao, showModal:false})}
                heigth="auto"
                open={showMovItensCanalDist?.showModal as boolean}
                width="md"
                handleOnKeyDown={(ev)=>{ev.preventDefault()}}
            />
        )
    }

    const setMov = (row:Movimentacao) => {
        console.log("set Mov",row);
        setShowMovItensCanalDist({mov:row,showModal:true})
    }

    return (
        <Box>
            <ViewList
                displayWidth={window.innerWidth}
                title={`Movimentações do Canal de Distribuição`}
                
                row={row}
                showAlert={false}
                closeAlert={() => { }}
                msg={""}
                status={""}
                elevation={1}
                getRowId={(row: Movimentacao) => row._id}
                handleOnChange={(row) => {}}
                actionsOnkeyEnter={(row) => {}}
                showSearchContainer={false}
                fontSize={14}
                setTextSearch={() => { }}
                textSearch={"codigo"}
                fieldSearch={""}
                columns={columns}
                rows={rowsMovCanal}
                loading={loading}
                setRow={() => { }}
                changeList={changeList}
                variantToobar="dense"
                buttonNew={{
                    show: false,
                    onClick: () => { }
                }}
                buttonRefresh={{
                    show: true,
                    onClick: () => loadMovimentacoes(),
                }}
                ListItemTextPrimary={(row: Movimentacao) => <Typography component={"span"}>{row.pessoa.nome}</Typography>}
                ListItemTextSecondary={(row: Movimentacao) =>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography component={"span"}>{row.codigo}</Typography>
                        <Typography component={"span"}>{formatMoney(row.fechamento.total)}</Typography>
                    </Box>
                }
            />
            <Box sx={{ mt: 2, display: 'flex', flexDirection: "row", justifyContent: 'flex-end' }}>
                <Typography variant="subtitle1">Total Movimentações: </Typography>
                <Typography variant="subtitle1" color="success">{formatMoney(rowsMovCanal.reduce((acc, mov) => acc + mov.fechamento.total, 0))}</Typography>
            </Box>
            <ViewItensMovModal />
            <MovCadastroView />
        </Box>
    )
}